export enum AlertSections {
  RULES_LIST,
	RULES_SELECT,
	RULES_CREATE
}